import {
  SELECT_RETURN_METHOD,
  RECEIVE_RETURN_METHODS,
  RESET_RETURN_METHOD,
} from '../../actions/returnMethods';

export const initialState = {
  selectedMethod: {},
  selectedMethodKey: '',
  returnMethods: [],
};

export default (
  state = initialState,
  { type, data: { selectedMethod, selectedMethodKey, returnMethods } = {} } = {},
) => {
  switch (type) {
    case RECEIVE_RETURN_METHODS:
      return {
        ...state,
        returnMethods,
      };

    case SELECT_RETURN_METHOD:
      return {
        ...state,
        selectedMethod,
        selectedMethodKey,
      };

    case RESET_RETURN_METHOD:
      return {
        ...state,
        selectedMethod: initialState.selectedMethod,
        selectedMethodKey: initialState.selectedMethodKey,
      };


    default:
      return state;
  }
};
